import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Product } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-product-main-heading',
  templateUrl: './product-main-heading.component.html',
  styleUrls: ['./product-main-heading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductMainHeadingComponent implements OnInit {
  @Input()
  product: Product;

  public isColorDisplayed: boolean;

  private otherColorLang = ['Other', 'Autre', 'Andere', 'Altro', 'Otro'];

  public ngOnInit() {
    this.isColorDisplayed = this.shouldDisplayColor(this.product);
  }

  private shouldDisplayColor(product: Product) {
    if (!product?.color?.localizedName) {
      return false;
    }

    return !this.otherColorLang.some(color => color === product.color.name);
  }
}
